exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".universal-data-access-container section.padded {\n  padding: 0 !important;\n}\n.universal-data-access-container section .toolbox {\n  margin-left: 0 !important;\n}\n.universal-data-access-container .rt-table {\n  overflow: unset !important;\n}\n.universal-data-access-container .rt-table .rt-resizable-header-content {\n  padding: 4px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/universaldataexport/index.less
// module id = 3775
// module chunks = 0